var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define('score_ccf/XPerience/Actions/CompleteGoalAction',["require", "exports", "jquery", "loglevel", "./../XPActionBase"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var $ = require("jquery");
    var log = require("loglevel");
    var XPActionBase_1 = require("./../XPActionBase");
    var CompleteGoalAction = /** @class */ (function (_super) {
        __extends(CompleteGoalAction, _super);
        function CompleteGoalAction(attributes) {
            var _this = _super.call(this, attributes) || this;
            _this.apiEndpoint = "/scoreui/triggergoal/{goalid}";
            return _this;
        }
        CompleteGoalAction.prototype.execute = function (component) {
            var url = this.apiEndpoint.replace("{goalid}", this.goalid);
            var that = this;
            $.post(url, { goalId: this.goalid }, function (response) {
                if (response.error) {
                    throw new Error(response.error);
                }
                if (response.success) {
                    log.debug("Goal triggered: " + that.goalid);
                }
            }, "json");
        };
        return CompleteGoalAction;
    }(XPActionBase_1.XPActionBase));
    exports.default = CompleteGoalAction;
});
//# sourceMappingURL=CompleteGoalAction.js.map;
